import moment from "moment";
import { useEffect, useState } from "react";
import { useAuthState } from "../../../../../helper/Context/context";

const positions = [
  { top: "8%", left: "5%" },
  { top: "8%", right: "5%" },
  { bottom: "12%", left: "5%" },
  { bottom: "12%", right: "5%" },
  { top: "45%", left: "35%" },
];

export default function ProtectedVideo({ userEmail = "Authorized User" }) {
  const [positionIndex, setPositionIndex] = useState(0);

  const userDetails = useAuthState()
  const { year, Month, Language } = userDetails
  const { UserID, token, UserName } = userDetails.user


  useEffect(() => {
    const timer = setInterval(() => {
      setPositionIndex((previous) =>
        (previous + 1) % positions.length
      );
    }, 10000); // Move every 10 seconds

    return () => clearInterval(timer);
  }, []);

  const watermarkStyle = {
    position: "absolute",
    ...positions[positionIndex],
    zIndex: 2,
    color: "rgba(255,255,255,0.8)",
    background: "rgba(0,0,0,0.4)",
    padding: "8px 12px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: 600,
    pointerEvents: "none",
    userSelect: "none",
    WebkitUserSelect: "none",
    maxWidth: "min(80%, 280px)",
    overflowWrap: "anywhere",
    textShadow: "0 1px 2px rgba(0,0,0,0.75)",
  };

  return (
    <div style={watermarkStyle} aria-hidden="true">
      {UserName}
      <br />
      {moment().format('DD-MM-YYYY')}
    </div>
  );
}
